import { useContext, useEffect, useState } from "react";
import { FormBuilderContext } from "../FormBuilderContext";
import "./Inputs.less";
import InputActions from "../InputActions/InputActions";
import IntlMessages from "../../../../util/IntlMessages";
import { getDecorators } from "../../../../util/getDecorators";
import { highlight, updateViewOptionsDecorator } from "../utils";
import { useTokenInput } from "../../../../Hooks/useTokenInput";

const TextInput = ({ item, onStartEdit, onDuplicate, onDelete }) => {
   const { previewMode, updateItem } = useContext(FormBuilderContext);
   const decoratorMap = getDecorators(item.decorators);

   const required = decoratorMap?.RequiredDecorator?.required ?? false;
   const hide = decoratorMap?.HideFieldDecorator?.hide ?? false;
   const editable = decoratorMap?.EditableDecorator?.edit ?? true;
   if (previewMode && (item.hidden || hide)) return null;

   const { inputValue, handleChange, handleCursor, handleKeyDown } = useTokenInput({
      value:
         item.decorators?.find((d) => d.name === "ViewOptionsDecorator")?.properties?.fieldsView ||
         "",
      onChange: (val) => {
         updateItem(item.uuid, (old) => updateViewOptionsDecorator(old, val));
      },
   });

   useEffect(() => {
      const decoratorValue =
         item.decorators?.find((d) => d.name === "ViewOptionsDecorator")?.properties?.fieldsView ||
         "";

      if (decoratorValue !== inputValue) {
         handleChange(decoratorValue);
      }
   }, [JSON.stringify(item.decorators)]);

   useEffect(() => {
      if (inputValue === undefined) return;

      const timeout = setTimeout(() => {
         updateItem(item.uuid, (old) => updateViewOptionsDecorator(old, inputValue));
      }, 50);

      return () => clearTimeout(timeout);
   }, [inputValue]);

   return (
      <>
         <label htmlFor={item?.name} className="form-builder-input-label">
            {(item.required || required) && <span className="form-builder-input-required">*</span>}
            {item.label}
            {(item.hidden || hide) && (
               <span className="form-builder-input-label-hidden">
                  ( (<IntlMessages id="form.hiddenField" />
                  ))
               </span>
            )}
            :
         </label>
         <div
            className="form-builder-input"
            onClick={!previewMode ? onStartEdit : undefined}
            role={!previewMode ? "button" : undefined}
            tabIndex={!previewMode ? 0 : undefined}
         >
            <div className="npf-input-container">
               <div
                  className="highlight-layer"
                  dangerouslySetInnerHTML={{ __html: highlight(inputValue || "") }}
               />

               <input
                  className="npf-input"
                  spellCheck="false"
                  value={inputValue}
                  onChange={(e) => handleChange(e.target.value)}
                  onClick={handleCursor}
                  onKeyUp={handleCursor}
                  onKeyDown={handleKeyDown}
               />
            </div>

            <InputActions onStartEdit={onStartEdit} onDuplicate={onDuplicate} onDelete={onDelete} />
         </div>
      </>
   );
};

export default TextInput;
